/**=========date start==========**/
export const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DATE = 'YYYY-MM-DD';
export const TIME = 'HH:mm';
/**=========date end==========**/

/**=========event bus start==========**/
export const EVENT_GO_TO_LOGIN_KEY = 'event_go_to_login_key';
/**=========event bus end==========**/
